"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var SimpleAPIData = /** @class */ (function () {
    function SimpleAPIData(data) {
        this.data = data;
    }
    /**
     * Get the ID of this object.
     * @returns {string|null} The ID of the object
     */
    SimpleAPIData.prototype.id = function () {
        if (this.data.hasOwnProperty("id")) {
            return this.data.id;
        }
        else {
            return null;
        }
    };
    /**
     * Get a specific value from this object if it exists.
     * if it does not return the fallback.
     * @param field {string}
     * @param fallback {any}
     * @returns any
     */
    SimpleAPIData.prototype.get = function (field, fallback) {
        if (fallback === void 0) { fallback = null; }
        if (this.has(field)) {
            if (this.data.hasOwnProperty("typeBound") && this.data.typeBound) {
                return this.data.attributes[field].value;
            }
            else {
                return this.data.attributes[field];
            }
        }
        else {
            return fallback;
        }
    };
    /**
     * Gets a specific date value from this object
     * @param field {string}
     * @param fallback {any}
     */
    SimpleAPIData.prototype.getDate = function (field, fallback) {
        if (fallback === void 0) { fallback = null; }
        /*
         * Get the value via the get method.
         */
        var value = this.get(field, fallback);
        /*
         * If the value isn't null, then try to parse it
         */
        if (value !== null) {
            return date_fns_1.parseISO(value);
        }
        return value;
    };
    /**
     * Get a specific boolean value from this object
     * @param field
     * @param fallback
     */
    SimpleAPIData.prototype.getBool = function (field, fallback) {
        if (fallback === void 0) { fallback = false; }
        /*
         * Get the value via the get method.
         */
        var value = this.get(field, fallback);
        if (field !== null) {
            return Boolean(value);
        }
        return fallback;
    };
    /**
     * Get a specific capability field if it exists on the object otherwise
     * return the fallback
     * @param field {string}
     * @param fallback {boolean}
     */
    SimpleAPIData.prototype.getCapability = function (field, fallback) {
        if (fallback === void 0) { fallback = false; }
        /*
         * Check to see if the capability exists first.
         */
        if (this.hasCapability(field)) {
            return this.data.capabilities[field];
        }
        else {
            return fallback;
        }
    };
    /**
     * Get a specific meta field if it exists on the object, otherwise return
     * the fallback value.
     * @param field {string}
     * @param fallback {any}
     */
    SimpleAPIData.prototype.getMeta = function (field, fallback) {
        if (fallback === void 0) { fallback = null; }
        /*
         * Check to see if the meta exists first.
         */
        if (this.hasMeta(field)) {
            return this.data.meta[field];
        }
        else {
            return fallback;
        }
    };
    /**
     * Check to see if the provided capability exists on this object.
     * @param field {string}
     * @returns {boolean}
     */
    SimpleAPIData.prototype.hasCapability = function (field) {
        return (this.data.hasOwnProperty("capabilities") &&
            this.data.capabilities.hasOwnProperty(field));
    };
    /**
     * Check to see if the provided meta field exists on this object.
     * @param field {string}
     * @returns {boolean}
     */
    SimpleAPIData.prototype.hasMeta = function (field) {
        return (this.data.hasOwnProperty("meta") && this.data.meta.hasOwnProperty(field));
    };
    /**
     * Check to see if the provided data attribute exists on this object.
     * @param field {string}
     * @returns {boolean}
     */
    SimpleAPIData.prototype.has = function (field) {
        return (this.data.hasOwnProperty("attributes") &&
            this.data.attributes.hasOwnProperty(field));
    };
    /**
     * Checks to see if a collection of fields exists on the data object.
     * returns TRUE if valid or an array of missing fields if not.
     * @param requiredFields {String|String[]}
     * @returns {String[]|Boolean}
     */
    SimpleAPIData.prototype.validateRequiredFields = function (requiredFields) {
        /*
         * If RequiredFields is not an array, make it one.
         */
        if (!Array.isArray(requiredFields)) {
            requiredFields = [requiredFields];
        }
        var missingFields = [];
        /*
         * Loop over all supplied RequiredFields and check to see if they exist.
         */
        for (var i in requiredFields) {
            if (requiredFields.hasOwnProperty(i)) {
                if (!this.has(requiredFields[i])) {
                    missingFields.push(requiredFields[i]);
                }
            }
        }
        return missingFields.length === 0 ? true : missingFields;
    };
    /**
     * Checks to see if a collection of constraints exists on the data object.
     * returns TRUE if valid or an array of missing constraints if not.
     * @param requiredFields
     * @returns {Array}
     */
    SimpleAPIData.prototype.validateRequiredCapabilities = function (requiredFields) {
        /*
         * If RequiredFields is not an array, make it one.
         */
        if (!Array.isArray(requiredFields)) {
            requiredFields = [requiredFields];
        }
        var missingFields = [];
        /*
         * Loop over all supplied RequiredFields and check to see if they exist.
         */
        for (var i in requiredFields) {
            if (requiredFields.hasOwnProperty(i)) {
                if (!this.hasCapability(requiredFields[i])) {
                    missingFields.push(requiredFields[i]);
                }
            }
        }
        return missingFields.length === 0 ? true : missingFields;
    };
    /**
     * Get the raw data object
     */
    SimpleAPIData.prototype.raw = function () {
        return this.data;
    };
    return SimpleAPIData;
}());
exports.SimpleAPIData = SimpleAPIData;
//# sourceMappingURL=data:application/json;base64,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